"use strict";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(generator);

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
/**
 * Arithmetic
 *
 * @param {*} start The number to start at
 * @param {*} commonDifference The number to increment by each time
 *
 * Produces an arithmetic number sequence. Arithmetic number
 * sequences are sequences which add or subtract a certain amount
 * for each iteration.
 */
// Public API
exports.default = function (start, commonDifference) {
  return (0, immutable_1.Seq)(generator(start, commonDifference));
};
// Generator
function generator() {
  var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var commonDifference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return regeneratorRuntime.wrap(function generator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return current;

        case 2:
          return _context.delegateYield(generator(current + commonDifference, commonDifference), "t0", 3);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}
//# sourceMappingURL=arithmetic.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/arithmetic.js
// module id = 273
// module chunks = 0